export default "__VITE_ASSET__ad727d0a__"